import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { catchError, map, mergeMap, Observable, of, take, timeout } from "rxjs";
import { JWT } from 'aws-amplify/auth';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);

    private getToken = (): Observable<JWT | undefined | null> => {
        return this.authService.getAuthSession().pipe(
            timeout(15000),
            map((session: any) => {
                return session.tokens?.idToken;
            }),
            catchError((error) => {
                console.warn('Auth session fetch error:', error);
                return of(null);
            }),
        );
    };

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.getToken().pipe(
            take(1),
            mergeMap((token) => {
                let headers = req.headers.set('Content-Type', 'application/json');
                
                if (token) {
                    headers = headers.set('Authorization', token.toString());
                }
                
                const cloned = req.clone({ headers });
                return next.handle(cloned);
            }),
            catchError((error) => {
                // console.error('HTTP Interceptor error:', error);
                // Return the request without auth header on error to allow the request to proceed
                return next.handle(req);
            }),
        );
    }
}